import { render, staticRenderFns } from "./Menu808.vue?vue&type=template&id=eba5a912"
import script from "./Menu808.vue?vue&type=script&lang=js"
export * from "./Menu808.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports